import { Injectable } from '@angular/core';
import {environment} from '@environment/environment';
import {HttpClientWrapper} from '@apply4u/services/httpclientwrapper';
import { UserPageVisit } from '@apply4u/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserPageVisitService {

  baseUrl:string = environment.BaseUrl;
  constructor(private httpService: HttpClientWrapper) { }
  
  get(userId:number,pageTitleId:number):Observable<UserPageVisit[]>{
    let url = this.baseUrl + `api/UserPageVisit/search?userId=${userId}&pageTitleId=${pageTitleId}`;
    return this.httpService.GetAsync<UserPageVisit[]>(url);
  }

  save(userPageVisit:UserPageVisit):Observable<number>{
    return this.httpService.PostAsync<number>(this.baseUrl + "api/UserPageVisit",userPageVisit);
  }

  update(userPageVisitId:number, userPageVisit:UserPageVisit):Observable<number>{
    return this.httpService.PutAsync<number>(this.baseUrl + `api/UserPageVisit/userPageVisitId?userPageVisitId=${userPageVisitId}`,userPageVisit);
  }

  sendPricingPageFollowUpEmail(pageTitleId:number, userId:number, selectedDashBoardTypeId: number){
    return this.httpService.PutAsync<number>(this.baseUrl + `api/UserPageVisit/PricingPageEmail?pageTitleId=${pageTitleId}&userId=${userId}&selectedDashBoardTypeId=${selectedDashBoardTypeId}`,null);
  }
}
